import { Pageview } from "@mui/icons-material";
import CategoryIcon from "@mui/icons-material/Category";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Paper,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link, useLoaderData } from "react-router-dom";
import { Result } from "../../../types/Result";
import { ExamType } from "../../examType/type";

export default function ExamTypeSummary() {
  const data = useLoaderData() as Result<ExamType[]>;
  const examTypes = data.data! as ExamType[];
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Sınav Tipleri ve Kategorileri
      </Typography>

      {examTypes.map((examType) => (
        <Accordion
          key={examType.code}
          expanded={expanded === examType.code}
          onChange={handleChange(examType.code)}
          sx={{ mb: 2 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${examType.code}-content`}
            id={`${examType.code}-header`}
          >
            <Box sx={{ width: "100%" }}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {examType.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Kod: {examType.code}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {examType.explanation}
              </Typography>

              {examType.examSectionTypes &&
              examType.examSectionTypes.length > 0 ? (
                <Box>
                  {examType.examSectionTypes.map((sectionType) => (
                    <Card key={sectionType.examSectionTypeCode} sx={{ mb: 1 }}>
                      <CardHeader
                        title={
                          <>
                            {sectionType.examSectionName}{" "}
                            <Chip
                              label={sectionType.examTypeCategories
                                .map((d) => d.questions.length)
                                .reduce((a, b) => a + b, 0)}
                              color="primary"
                            />
                          </>
                        }
                        subheader={
                          <ListSubheader>
                            {sectionType.examSectionTypeCode}
                          </ListSubheader>
                        }
                        action={
                          <IconButton
                            component={Link}
                            to={sectionType.examTypeCode}
                          >
                            <Pageview />
                          </IconButton>
                        }
                      />

                      {sectionType.examTypeCategories &&
                      sectionType.examTypeCategories.length > 0 ? (
                        <Box sx={{ ml: 2, mt: 1 }}>
                          <List dense disablePadding subheader={"Kategoriler"}>
                            {sectionType.examTypeCategories.map((category) => (
                              <ListItem
                                key={category.categoryCode}
                                sx={{ py: 0.5 }}
                                secondaryAction={
                                  <IconButton
                                    component={Link}
                                    to={`/examTypeCategories/${sectionType.examTypeCode}/${category.categoryCode}`}
                                  >
                                    <Pageview />
                                  </IconButton>
                                }
                              >
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                  <CategoryIcon
                                    fontSize="small"
                                    color="primary"
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={
                                    <>
                                      {category.categoryName}{" "}
                                      <Chip
                                        label={`${category.questions.length} Soru`}
                                      />
                                    </>
                                  }
                                  secondary={`Kod: ${category.categoryCode}`}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                      ) : (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ ml: 2 }}
                        >
                          Kategori bulunmuyor
                        </Typography>
                      )}
                    </Card>
                  ))}
                </Box>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Bu sınav tipi için bölüm bulunmuyor.
                </Typography>
              )}

              {examType.exams && examType.exams.length > 0 && (
                <Box sx={{ mt: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: "bold" }}
                  >
                    Toplam Sınav Sayısı
                  </Typography>
                  <Chip
                    label={`${examType.exams.length} Sınav`}
                    color="secondary"
                    variant="outlined"
                  />
                </Box>
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}

      {examTypes.length === 0 && (
        <Paper sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h6" color="text.secondary">
            Henüz sınav tipi eklenmemiş.
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
